import SeoNavigationLinks from './SeoNavigationLinks'

export default SeoNavigationLinks
// eslint-disable-next-line import/export
export * from './SeoNavigationLinks'
